export const CardData = () => [
    {
        title: 'Customization at its Core',
        body: `We understand that every business is unique. Our team of experienced developers crafts bespoke software solutions, ensuring that each line of code aligns perfectly with your business goals and objectives.`,
        image: 'customize.jpeg'
    },
    {
        title: 'Seamless Integration',
        body: `Our software seamlessly integrates with your existing systems, creating a harmonious technological environment. This ensures a smooth transition and minimizes disruption to your day-to-day operations`,
        image: 'integration.jpeg'
    },
    {
        title: 'User-Centric Design',
        body: `User experience is at the forefront of our software development process. We prioritize intuitive interfaces and user-friendly designs, making it easy for your team to adapt and maximize productivity.`,
        image: 'integration.jpeg'
    },
    {
        title: 'Scalability for the Future',
        body: `As your business grows, so should your software. Our solutions are designed with scalability in mind, ensuring that they evolve alongside your organization and can easily accommodate increasing demands.`,
        image: 'integration.jpeg'
    },
    {
        title: 'Cutting-Edge Technologies',
        body: `Stay ahead of the curve with our use of the latest technologies. We leverage the power of artificial intelligence, machine learning, and other emerging trends to future-proof your software and keep you at the forefront of innovation.`,
        image: 'integration.jpeg'
    },
    {
        title: 'Reliable Support',
        body: `Our commitment doesn't end with the delivery of the software. Our dedicated support team is always ready to assist you, providing timely updates, troubleshooting, and continuous improvement to keep your software running smoothly.`,
        image: 'integration.jpeg'
    },
]

export const stackData = () => [
    {
        name: 'React',
        image: 'stack/react.png'
    },
    {
        name: 'Angular',
        image: 'stack/angular.png'
    },
    {
        name: 'Node',
        image: 'stack/node.png'
    },
    {
        name: 'Typescript',
        image: 'stack/typescript.svg'
    },
    {
        name: 'GraphQL',
        image: 'stack/graphQl.png'
    },
    {
        name: 'Mongo DB',
        image: 'stack/mongodb.svg'
    },
    {
        name: 'mySql',
        image: 'stack/mysql.svg'
    },
    {
        name: 'Redis',
        image: 'stack/redis.svg'
    },
    {
        name: 'Material UI',
        image: 'stack/mui.png'
    },
    {
        name: 'Bootstrap',
        image: 'stack/bootstrap.jpeg'
    },
    {
        name: 'Ant Design',
        image: 'stack/ant.jpeg'
    },
    {
        name: 'HTML',
        image: 'stack/html.png'
    },
    {
        name: 'CSS',
        image: 'stack/css.jpeg'
    },
    {
        name: 'github',
        image: 'stack/github.png'
    },
    {
        name: 'NPM',
        image: 'stack/npm.png'
    },
    {
        name: 'SASS',
        image: 'stack/sass.png'
    },
    // {
    //     name: 'Jira',
    //     image: 'stack/jira.svg'
    // },
    // {
    //     name: 'Monday',
    //     image: 'stack/monday.webp'
    // },
]